import Vue from 'vue';
import axios from 'axios';

Vue.component('model-car-stock', {
    props: {
        cdnUrl: {
            type: String,
        },
        defaultValue: {
            type: String,
        },
        defaultHref: {
            type: String,
        },
    },

    data() {
        return {
            stockCount: null,
            currentModel: null,
            currentLabel: null,
            currentHref: this.defaultHref,
            dropdownImage: '',
        };
    },

    async mounted() {
        this.currentModel = this.defaultValue;
        this.currentLabel = this.currentModel.toUpperCase().replace('-', ' ');
        this.currentHref = this.defaultHref + this.currentModel;

        await this.getCarStockCount();

        const defaultValueTargetImage =
            '/images/model/dropdown-new-' + this.currentModel + '.png';

        this.dropdownImage = this.cdnUrl + defaultValueTargetImage;
    },

    methods: {
        async getCarStockCount() {
            try {
                //Using Fetch here because axios is not working in this case and is throwing CORS errors
                fetch(
                    `https://store.mgmotor.fr/collections/${this.currentModel}.json`,
                )
                    .then((response) => response.json())
                    .then((data) => {
                        this.stockCount = data.collection.products_count;
                    });
            } catch (e) {
                return e;
            }
        },

        setDropdownValue(event) {
            event.preventDefault();
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            const label = event.currentTarget.dataset.label;
            this.dropdownImage =
                this.cdnUrl + event.currentTarget.dataset.image;

            this.currentModel = value;
            this.currentLabel = label;
            this.currentHref = this.defaultHref + this.currentModel;

            this.getCarStockCount();
        },

        toggleDropdown(event) {
            let element = event.currentTarget;

            while ((element = element.parentElement)) {
                if (element.classList.contains('dropdown')) {
                    element.classList.toggle('dropdown--active');
                }
            }
        },
        // Hotfix for removing year 2023 from model name
        // that should be used until we find alternative solution
        // or until all the countries use hs and ehs model from 2023
        newModelsFormatHotfix(modelName) {
            if (!modelName) {
                return '';
            }
            return modelName.replace(' 2023', '');
        },
    },
});
